import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';
import Input from '../ui/Input';
import Button from '../ui/Button';
import { useAdminAuth } from '../../context/AuthContext';
import { LogIn, Shield } from 'lucide-react';

/** Portail admin séparé — URL non publiée sur le site public */
const AdminLogin: React.FC = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const { login } = useAdminAuth();

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setIsLoading(true);
        setError('');
        try {
            const { data } = await api.post('/auth/login', { email, password });
            if (data.user?.role !== 'admin') {
                setError('Ce compte n’est pas administrateur.');
                return;
            }
            login(data.user, data.token);
            navigate('/bo-flashcv', { replace: true });
        } catch (err: any) {
            setError(err.response?.data?.error || err.message || 'Identifiants invalides');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center px-4 py-12 bg-slate-950">
            <div className="max-w-md w-full">
                <div className="text-center mb-8">
                    <div className="inline-flex items-center justify-center p-3 bg-indigo-600 rounded-2xl mb-5">
                        <Shield className="w-8 h-8 text-white" />
                    </div>
                    <h1 className="text-2xl font-extrabold text-white tracking-tight">FlashCV Console</h1>
                    <p className="text-slate-400 text-sm mt-1">Accès administrateur uniquement</p>
                </div>

                <div className="bg-white rounded-2xl p-8 shadow-xl space-y-5">
                    <form className="space-y-5" onSubmit={handleSubmit}>
                        <Input
                            label="Email admin"
                            type="email"
                            placeholder="admin@…"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                        <Input
                            label="Mot de passe"
                            type="password"
                            placeholder="••••••••"
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                        {error && (
                            <div className="p-3 bg-red-50 border border-red-100 rounded-xl text-red-600 text-sm text-center">
                                {error}
                            </div>
                        )}
                        <Button type="submit" className="w-full h-11" isLoading={isLoading}>
                            <LogIn className="w-4 h-4 mr-2" />
                            Ouvrir le backoffice
                        </Button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default AdminLogin;
